import { Directive, ElementRef, HostListener, OnDestroy, Self } from '@angular/core';

@Directive({
  selector: '[appFocusRemove]',
  standalone: true,
})
export class FocusRemoverDirective implements OnDestroy {
  readonly lockTime = 250;

  constructor(@Self() private elRef: ElementRef) {}

  private intervalId: any;

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  @HostListener('click')
  onClick(): void {
    setTimeout(() => this.elRef.nativeElement.blur());
    const button = this.elRef.nativeElement as HTMLButtonElement;
    button.style.pointerEvents = 'none';
    this.intervalId = setTimeout(() => {
      button.style.pointerEvents = 'auto';
    }, this.lockTime);
  }
}
